import $ from "jquery";

$(document).ready(function() {
    $('.card-stats-item-title').each(function() {
        var $this = $(this);
        var finalNumber = parseInt($this.data('number'), 10) || 0;
        
        // Pick a random duration (1-5 seconds, in milliseconds)
        var randomDuration = (Math.floor(Math.random() * 5) + 1) * 1000;

        // Utility to format numbers with commas
        function formatNumber(num) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        // Animate from 0 up to finalNumber
        function animateCount() {
            var start = 0;
            var startTime = Date.now();
            var endTime = startTime + randomDuration;

            function update() {
                var now = Date.now();
                var progress = (now - startTime) / (endTime - startTime);
                if (progress > 1) progress = 1;

                var current = Math.floor(start + (finalNumber - start) * progress);
                $this.find('.number').text(formatNumber(current));

                // Continue animating until we reach finalNumber
                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            }
            requestAnimationFrame(update);
        }

        // Observe when the item comes into and out of view
        var observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                // When in view, animate counting up
                if (entry.isIntersecting) {
                    animateCount();
                } else {
                    // Reset to 0 when out of view
                    var replacedText = $this.html().replace('{{number}}', 0);
                    $this.html(replacedText);
                }
            });
        });

        observer.observe($this[0]);
    });

    function toggleExtraPadding() {
        $('.card-stats-item.col-2').each(function() {
            $(this).toggleClass('extra_padding');
        });
    }

    // Set interval to toggle the class every 5 seconds
    setInterval(toggleExtraPadding, 5000);
});